module.exports = __webpack_public_path__ + "img/download-table-blue-icon.0f74895c.svg";